import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Merci pour votre évaluation !',
  text: 'Y a-t-il quelque chose que nous pouvons améliorer ? Donnez-nous votre avis.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Votre avis...'
      }
    ],
    submit: {
      label: 'Envoyer'
    }
  }
};
